export default function transformIdList(listString) {
  if (!listString) {
    return [];
  }
  return listString.toString().split(',').map(Number);
}
